/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 * @includeModules QImageSetX,QFontSetX
 * @flow
 */

global.__DEV__ = false;

import 'babel-polyfill'
import React from 'react';
import { Text, TextInput } from 'react-native';

import '@qnpm/react-native-ext';
import '@qnpm/react-native-ext-fetch';
import './config';
import './src';

import { FontLoader } from 'qunar-react-native';
FontLoader.loadFontSet(require('./src/lowPrice/assets/QFontSet'));

// 禁止字体缩放
Text.defaultProps = {
    ...(Text.defaultProps || {}),
    allowFontScaling: false
};

TextInput.defaultProps = {
    ...(TextInput.defaultProps || {}),
    allowFontScaling: false
};
